export default __webpack_public_path__ + "static/media/joint_MONUSCO_FARDC_operation.e595ebf2.jpg";